// How ideas in a family are related (docs/refactor-plan.md, Phase 4), shared by the server
// (src/lib/ideas/families.js) and the pages: how one came from another, and what a link is by how
// alike the two stayed. Under 45 alike they aren't family.
export const HOWS = ["grew", "bred", "edited", "variation", "modified", "heard", "banded", "remixed", "captured"];
export const FAMILY_MIN = 45;
export const kinship = (similarity) => similarity == null ? null : similarity >= 90 ? "copy" : similarity >= 70 ? "variation" : similarity >= FAMILY_MIN ? "inspired by" : null;
